import React from 'react';
import { ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';

const WebsitesPage = ({ websites }) => {
  return (
    <div className="pt-24 pb-16">
      <div className="section">
        <div className="max-w-7xl mx-auto">
          <h1 className="section-title text-center">Websites & Platforms</h1>
          <p className="text-gray-400 text-center max-w-3xl mx-auto mb-12">
            Check out the websites and platforms I've created and maintain.
          </p>
          
          {/* Websites List */}
          <div className="space-y-12">
            {websites.map(website => (
              <div key={website.id} className="card overflow-hidden">
                <div className="grid grid-cols-1 md:grid-cols-2">
                  <div className="relative h-64 md:h-auto overflow-hidden">
                    {website.video ? (
                      <video
                        src={website.video}
                        poster={website.image}
                        className="w-full h-full object-cover"
                        autoPlay
                        muted
                        loop
                        playsInline
                        controls
                      >
                        <img src={website.image} alt={website.name} />
                      </video>
                    ) : (
                      <img
                        src={website.image}
                        alt={website.name}
                        className="w-full h-full object-cover"
                      />
                    )}
                    <div className="absolute inset-0 bg-gradient-to-r from-dark-900 to-transparent md:bg-gradient-to-t opacity-70"></div>
                    <div className="absolute bottom-0 left-0 p-6 md:hidden">
                      <h3 className="text-2xl font-bold text-white">{website.name}</h3>
                    </div>
                  </div>
                  
                  <div className="p-6 md:p-8 flex flex-col justify-between">
                    <div>
                      <h3 className="hidden md:block text-2xl font-bold text-white mb-4">{website.name}</h3>
                      <p className="text-gray-300 mb-6 leading-relaxed">
                        {website.description}
                      </p>
                      
                      <div className="flex flex-wrap gap-2 mb-6">
                        {website.technologies.map((tech, index) => (
                          <span key={index} className="skill-badge">
                            {tech}
                          </span>
                        ))}
                      </div>
                    </div>
                    
                    <div>
                      <a 
                        href={website.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-primary flex items-center justify-center md:justify-start"
                      >
                        <ArrowTopRightOnSquareIcon className="h-5 w-5 mr-2" />
                        Visit Website
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WebsitesPage;
